import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export const ProductNav = ({ prev, next }) => (
  <section className="py-16 bg-primary text-primary-foreground">
    <div className="container mx-auto grid sm:grid-cols-2 gap-5">
      <Link to={`/products/${prev.slug}`} className="group flex items-center gap-5 p-6 rounded-3xl bg-primary-foreground/5 border border-primary-foreground/15 hover:bg-primary-foreground/10 transition-colors">
        <div className="h-20 w-20 rounded-2xl overflow-hidden shrink-0">
          <img src={prev.image} alt={prev.name} className="h-full w-full object-cover" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-primary-foreground/60 flex items-center gap-1.5"><ArrowLeft className="h-3 w-3" /> Previous sheet</div>
          <div className="font-display text-xl font-medium mt-1 group-hover:text-accent transition-colors">{prev.name}</div>
        </div>
      </Link>
      <Link to={`/products/${next.slug}`} className="group flex items-center gap-5 p-6 rounded-3xl bg-primary-foreground/5 border border-primary-foreground/15 hover:bg-primary-foreground/10 transition-colors sm:text-right sm:flex-row-reverse">
        <div className="h-20 w-20 rounded-2xl overflow-hidden shrink-0">
          <img src={next.image} alt={next.name} className="h-full w-full object-cover" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-primary-foreground/60 flex items-center gap-1.5 sm:justify-end">Next sheet <ArrowRight className="h-3 w-3" /></div>
          <div className="font-display text-xl font-medium mt-1 group-hover:text-accent transition-colors">{next.name}</div>
        </div>
      </Link>
    </div>
  </section>
);

export default ProductNav;
